class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.predictiveSearchQueries = this.querySelector('#predictive-queries');
      this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.abortController = new AbortController();

      document.querySelector('.search-submit').addEventListener('click', (event) => {
        event.preventDefault()
        this.onChange(event);
      });


        document.querySelector('.search-input').addEventListener('keypress', this.debounce((event) => {

            event.preventDefault()
            this.onChange(event);
            var key = event.keyCode || event.charCode;

        }, 300).bind(this));


      document.querySelector('.search-submit').addEventListener('keypress', this.debounce((event) => {

        if (e.key === 'Enter' || key == 8 || key == 46) {
          event.preventDefault()
          this.onChange(event);
        }
      }, 300).bind(this));


      const SearchTag = document.querySelectorAll('.search-tag');
      SearchTag.forEach(tag => {
        tag.addEventListener('click', this.debounce((event) => {
          // event.preventDefault()
          document.getElementById('Search').value = tag.innerHTML
          document.querySelector('#Search').placeholder == tag.dataset.search;
          this.onTag(tag.dataset.search);
          document.querySelector('.clear-btn').classList.remove('hidden');

        }, 300).bind(this));
      });



      document.querySelector('.clear-btn').addEventListener('click', this.debounce((event) => {
        this.setAttribute('open', false);
        document.getElementById('Search').value = "";
        this.input.value = '';
        event.preventDefault()
        this.onChange(event);
        document.querySelector('.clear-btn').classList.add('hidden');
      }, 300).bind(this));

          //Toggle add to wishlist modal
   
  
    }

    onTag(e) {
        const searchTerm = e;
        if (!searchTerm.length) {
          this.close();
          return;
        }
        this.getSearchResults(searchTerm);
    }
  
  
    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      } 

      this.open();
      document.querySelector('.clear-btn').classList.remove('hidden');
      this.getSearchResults(searchTerm);
    }

  
  


    getSearchResults(searchTerm) {

      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
  
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[limit_scope]=each`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((text) => {

          if (window.matchMedia('(max-width: 769px)').matches) {   document.querySelector('.ps-suggestions').style.display = "none" }
        
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
       
        })
        .catch((error) => {

          throw error;
        });
        
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  


  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }


    open() {
      this.setAttribute('open', true);
    }
    close(clearSearchTerm = false) {
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
    }
    closeResults(clearSearchTerm = false) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.setAttribute('open', false);
      }
    }

  }
  customElements.define('predictive-search', PredictiveSearch);


